import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { isAvailableCurrencyCode } from '../../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
export function AddOnPricing({
  productApiName,
  price,
  isHubSpotCredits,
  packagedQuantities,
  currencyCode
}) {
  const resolvedCurrencyCode = isAvailableCurrencyCode(currencyCode) ? currencyCode : 'USD';
  if (isHubSpotCredits) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceDisplay.highlightedPrice.pricePerCredits",
      options: {
        price: /*#__PURE__*/_jsx("span", {
          "data-selenium-id": `${productApiName}-price-per-credits`,
          children: /*#__PURE__*/_jsx(PriceDisplay, {
            price: price,
            currencyCode: resolvedCurrencyCode
          })
        }),
        packagedQuantities
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "priceComponents.pricePerMonth",
    options: {
      price: /*#__PURE__*/_jsx(PriceDisplay, {
        price: price,
        currencyCode: resolvedCurrencyCode,
        dataSelenium: `${productApiName}-price-per-month`
      })
    }
  });
}